"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./PushingTooltip.css");
var PushingTooltip = /** @class */ (function (_super) {
    __extends(PushingTooltip, _super);
    function PushingTooltip(props) {
        var _this = _super.call(this, props) || this;
        _this.idName = "PushingTooltip" + PushingTooltip.counter++;
        return _this;
    }
    PushingTooltip.prototype.getTooltipWidthStyles = function () {
        return {
            right: this.props.options && this.props.options.growRight ? 'auto' : '0',
            width: this.props.options && this.props.options.width ? this.props.options.width : '100%',
        };
    };
    PushingTooltip.prototype.render = function () {
        return this.getClickType();
    };
    PushingTooltip.prototype.getClickType = function () {
        var cssClasses = [
            this.props.data.showTooltip ? styles.animationExpand : styles.animationCollapse,
            this.props.options.className,
        ];
        return (React.createElement("div", { className: cssClasses.join(' ') },
            React.createElement("div", { className: this.props.options.isRennyStyle ? styles.pushingTooltipContainerRenny : styles.pushingTooltipContainer },
                React.createElement("div", __assign({ "data-test-id": this.props.testId, className: this.getContentClasses() }, this.getContentAccessibility(), { style: this.getTooltipWidthStyles() }), this.props.children))));
    };
    PushingTooltip.prototype.getContentClasses = function () {
        return [this.props.options.isRennyStyle ? styles.tooltipContentRenny : styles.tooltipContent,
            this.props.options.className,
            styles.controlled,
            styles.show].join(' ');
    };
    PushingTooltip.prototype.getContentAccessibility = function () {
        return {
            'aria-hidden': !this.props.data.showTooltip,
            'aria-live': 'polite',
            id: this.idName,
            role: 'tooltip',
        };
    };
    PushingTooltip.counter = 0;
    return PushingTooltip;
}(React.Component));
exports.default = PushingTooltip;
//# sourceMappingURL=PushingTooltip.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Tooltip/PushingTooltip/PushingTooltip.js
// module id = 1131
// module chunks = 8